import React from 'react';
import { ArrowRight, Play, CheckCircle2, TrendingUp } from 'lucide-react';

const Hero = () => {
  return (
    <section className="relative pt-32 pb-20 px-4 sm:px-6 lg:px-8 overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-indigo-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse"></div>
        <div className="absolute top-40 right-10 w-72 h-72 bg-purple-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse" style={{animationDelay: '2s'}}></div>
        <div className="absolute -bottom-8 left-1/2 w-72 h-72 bg-indigo-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse" style={{animationDelay: '4s'}}></div>
      </div>

      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          {/* Trust Badge */}
          <div className="inline-flex items-center space-x-2 bg-indigo-50 border border-indigo-200 rounded-full px-4 py-2 mb-6">
            <CheckCircle2 className="w-4 h-4 text-indigo-700" />
            <span className="text-sm font-semibold text-indigo-900">Trusted by 5,000+ Students & Professionals</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
            <span className="text-gray-900">Transform Your</span>
            <br />
            <span className="bg-gradient-to-r from-indigo-700 via-purple-700 to-indigo-700 bg-clip-text text-transparent">
              Global Dreams
            </span>
            <br />
            <span className="text-gray-900">Into Reality</span>
          </h1>

          {/* Subheading */}
          <p className="text-xl text-gray-600 mb-10 max-w-3xl mx-auto leading-relaxed">
            Navigate your journey to study, work, and settle abroad with India's most trusted consultancy. 
            <span className="font-semibold text-indigo-700"> 98% visa success rate</span> backed by 15+ years of expertise.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
            <button className="group relative">
              <div className="absolute -inset-0.5 bg-indigo-600 rounded-full blur opacity-75 group-hover:opacity-100 transition"></div>
              <div className="relative bg-indigo-700 hover:bg-indigo-800 text-white px-8 py-4 rounded-full text-lg font-semibold shadow-xl hover:shadow-2xl transition transform hover:scale-105 flex items-center space-x-2">
                <span>Start Your Journey Free</span>
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition" />
              </div>
            </button>
            
            <button className="group flex items-center space-x-2 px-8 py-4 bg-white border-2 border-gray-300 rounded-full text-lg font-semibold text-gray-700 hover:border-indigo-700 hover:text-indigo-700 transition shadow-md hover:shadow-lg">
              <Play className="w-5 h-5 fill-current" />
              <span>Watch Success Stories</span>
            </button>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap justify-center items-center gap-8 text-sm text-gray-500">
            <div className="flex items-center space-x-2">
              <CheckCircle2 className="w-4 h-4 text-green-500" />
              <span>No Hidden Charges</span>
            </div>
            <div className="flex items-center space-x-2">
              <CheckCircle2 className="w-4 h-4 text-green-500" />
              <span>100% Transparent Process</span>
            </div>
            <div className="flex items-center space-x-2">
              <CheckCircle2 className="w-4 h-4 text-green-500" />
              <span>End-to-End Support</span>
            </div>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="mt-16 grid grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto">
          {[
            { value: '5000+', label: 'Success Stories', sublabel: 'Since 2010' },
            { value: '98%', label: 'Visa Success Rate', sublabel: 'Industry Leading' },
            { value: '25+', label: 'Countries Covered', sublabel: 'Worldwide Service' },
            { value: '15+', label: 'Years Experience', sublabel: 'Expert Team' }
          ].map((stat, i) => (
            <div key={i} className="group bg-white rounded-2xl p-6 border border-gray-200 shadow-lg hover:shadow-2xl hover:border-indigo-300 transition transform hover:-translate-y-1">
              <div className="flex items-start justify-between mb-2">
                <div className="text-4xl font-bold text-indigo-700">
                  {stat.value}
                </div>
                <TrendingUp className="w-5 h-5 text-green-500" />
              </div>
              <div className="text-gray-600 font-medium">{stat.label}</div>
              <div className="text-xs text-gray-400 mt-1">{stat.sublabel}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
